<div class="wrapper">
  <div class="top-bar" *ngIf="!hideHeader">
    <div class="d-flex">
      <span (click)="goBack()">
        <img class="h-18" src="assets/images/icon/chevronleft.svg" />
        {{ translations['back_label'] }}
      </span>
      <span class="verticle-line"> </span>
      <span (click)="navigateToLadingPage()">
        <img src="assets/images/icon/refresh.svg" />
        {{ translations['restart'] }}
      </span>
    </div>
    <div>
      <div>
        <img
          src="assets/images/ecolab-logo-white-app-header.png"
          alt="EcoLab Logo"
          class="logo h-30"
        />
      </div>
    </div>
    <select
      [value]="currentLanguage"
      (change)="languageChange($event)"
      class="select-dropdown"
    >
      <option
        *ngFor="let option of languageOptions"
        [value]="option?.value"
        [selected]="option.value === currentLanguage"
      >
        {{ option.value }}
      </option>
    </select>
  </div>

  <div>
    <img
      class="img-trouble"
      src="assets/images/troubleshooting/ecolab100x.png"
    />
  </div>

  <div class="mt-4 thank-msg-text">
    {{ translations['contact_page_thank'] }}
  </div>

  <div class="mx-3">
    <hr />
  </div>

  <div class="mx-3">
    <h3>{{ translations['next_label'] }}</h3>
    <p>
      {{ translations['contact_message'] }}
      <!-- <span href="tel:1-800-352-5326" class="call-button">1-800-352-5326</span> -->
    </p>
  </div>
</div>
